module.exports = __webpack_public_path__ + "static/media/avatar.8a5aea13.png";